import React from 'react';
import PropTypes from 'prop-types';

function IconCollection({ color = '#8C8C8C', size = 24, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 6H21M8 12H21M8 18H21M3 6H3.01M3 12H3.01M3 18H3.01" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconCollection.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconCollection;
